// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_sidebar__Nl1c6 {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: var(--gray-000, #ffffff);
  border-right: 1px solid var(--gray-200, #e0e0e0);
}

.sidebar_topSection__kuCjJ {
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  background: #24b237;
}

.sidebar_logoContainer__r5Za\\+ {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  gap: 8px;
  color: #fff;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 3.33px;
  text-transform: capitalize;
}

.sidebar_dropdownToggle__azIBo {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 6px;
  transition: transform 0.18s ease;
  flex-shrink: 0;
}

.sidebar_dropdownToggle__azIBo:hover {
  opacity: 0.8;
}

.sidebar_dropdownIcon__PTq0j {
  transition: transform 0.2s ease;
}

.sidebar_dropdownIconOpen__bChHN {
  transform: rotate(180deg);
}

.sidebar_productCards__jyYWH {
  position: absolute;
  top: 70px;
  left: 150px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #ffffff;
  padding: 12px;
  width: 220px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
  z-index: 40;
}

.sidebar_productCard__4i3uS {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border: 1px solid rgba(16, 24, 40, 0.06);
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  transition: background-color 0.12s ease, transform 0.12s ease;
  width: 100%;
}

.sidebar_productCard__4i3uS:hover {
  background-color: rgba(80, 113, 255, 0.04);
  transform: translateY(-2px);
}

.sidebar_productIconContainer__XxOhA {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(80, 113, 255, 0.08);
  flex-shrink: 0;
}

.sidebar_productIcon__uxbA2 {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.sidebar_productLabel__aIaBu {
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-800, #2d2d2d);
  flex: 1 1;
}

.sidebar_nav__9wHm8 {
  display: flex;
  flex-direction: column;
  padding: 20px 12px;
  gap: 8px;
  flex: 1 1;
  overflow-y: auto;
}

.sidebar_navItem__m5pGi {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  text-align: left;
  color: var(--gray-700, #424242);
  transition: background-color 0.2s ease, color 0.2s ease;
}

.sidebar_active__bwzkn {
  background-color: var(--primary-500, #5071ff);
  color: #ffffff;
}

.sidebar_icon__YaRab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.sidebar_label__eUS1p {
  flex: 1 1;
  font-size: 14px;
  font-weight: 500;
}

.sidebar_logoutSection__rD-Qf {
  padding: 16px 20px 24px;
  border-top: 1px solid var(--gray-200, #e0e0e0);
}

.sidebar_logoutButton__CixpT {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--gray-700, #424242);
  transition: all 0.2s ease;
  text-align: center;
}

.sidebar_logoutButton__CixpT:hover {
  background-color: rgba(80, 113, 255, 0.08);
  color: #5071ff;
}

.sidebar_logoutButton__CixpT:active {
  background-color: rgba(80, 113, 255, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/modules/molecules/sidebar/sidebar.module.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,WAAA;EACA,0CAAA;EACA,gDAAA;AADF;;AAIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,0BAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;EACA,cAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,+BAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EACA,6CAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,wCAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,6DACE;EAEF,WAAA;AAHF;;AAMA;EACE,0CAAA;EACA,2BAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,cAAA;AAHF;;AAMA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAHF;;AAMA;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,+BAAA;EACA,uDACE;AAJJ;;AAQA;EACE,6CAAA;EACA,cAAA;AALF;;AAQA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;AALF;;AAQA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;EACE,uBAAA;EACA,8CAAA;AALF;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AALF;;AAQA;EACE,0CAAA;EACA,cAAA;AALF;;AAQA;EACE,0CAAA;AALF","sourcesContent":["// XSM-1536 - SSO Login flow\n// Author: Abhishek Bharti\n.sidebar {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  width: 100%;\n  background-color: var(--gray-000, #ffffff);\n  border-right: 1px solid var(--gray-200, #e0e0e0);\n}\n\n.topSection {\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  position: relative;\n  background: #24b237;\n}\n\n.logoContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  position: relative;\n  gap: 8px;\n  color: #fff;\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 3.33px;\n  text-transform: capitalize;\n}\n\n.dropdownToggle {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 6px;\n  transition: transform 0.18s ease;\n  flex-shrink: 0;\n}\n\n.dropdownToggle:hover {\n  opacity: 0.8;\n}\n\n.dropdownIcon {\n  transition: transform 0.2s ease;\n}\n\n.dropdownIconOpen {\n  transform: rotate(180deg);\n}\n\n.productCards {\n  position: absolute;\n  top: 70px;\n  left: 150px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #ffffff;\n  padding: 12px;\n  width: 220px;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);\n  z-index: 40;\n}\n\n.productCard {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border: 1px solid rgba(16, 24, 40, 0.06);\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  transition:\n    background-color 0.12s ease,\n    transform 0.12s ease;\n  width: 100%;\n}\n\n.productCard:hover {\n  background-color: rgba(80, 113, 255, 0.04);\n  transform: translateY(-2px);\n}\n\n.productIconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: rgba(80, 113, 255, 0.08);\n  flex-shrink: 0;\n}\n\n.productIcon {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n.productLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gray-800, #2d2d2d);\n  flex: 1;\n}\n\n.nav {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 12px;\n  gap: 8px;\n  flex: 1;\n  overflow-y: auto;\n}\n\n.navItem {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font: inherit;\n  text-align: left;\n  color: var(--gray-700, #424242);\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease;\n}\n\n.active {\n  background-color: var(--primary-500, #5071ff);\n  color: #ffffff;\n}\n\n.icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.label {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.logoutSection {\n  padding: 16px 20px 24px;\n  border-top: 1px solid var(--gray-200, #e0e0e0);\n}\n\n.logoutButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 12px 16px;\n  border: none;\n  background: transparent;\n  border-radius: 8px;\n  cursor: pointer;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--gray-700, #424242);\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.logoutButton:hover {\n  background-color: rgba(80, 113, 255, 0.08);\n  color: #5071ff;\n}\n\n.logoutButton:active {\n  background-color: rgba(80, 113, 255, 0.12);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `sidebar_sidebar__Nl1c6`,
	"topSection": `sidebar_topSection__kuCjJ`,
	"logoContainer": `sidebar_logoContainer__r5Za+`,
	"dropdownToggle": `sidebar_dropdownToggle__azIBo`,
	"dropdownIcon": `sidebar_dropdownIcon__PTq0j`,
	"dropdownIconOpen": `sidebar_dropdownIconOpen__bChHN`,
	"productCards": `sidebar_productCards__jyYWH`,
	"productCard": `sidebar_productCard__4i3uS`,
	"productIconContainer": `sidebar_productIconContainer__XxOhA`,
	"productIcon": `sidebar_productIcon__uxbA2`,
	"productLabel": `sidebar_productLabel__aIaBu`,
	"nav": `sidebar_nav__9wHm8`,
	"navItem": `sidebar_navItem__m5pGi`,
	"active": `sidebar_active__bwzkn`,
	"icon": `sidebar_icon__YaRab`,
	"label": `sidebar_label__eUS1p`,
	"logoutSection": `sidebar_logoutSection__rD-Qf`,
	"logoutButton": `sidebar_logoutButton__CixpT`
};
export default ___CSS_LOADER_EXPORT___;
